import validator from 'validator'
import { trimString } from '../utils/helper'

export const AddScheduleValidation = (data: any) => {
  let errors = {} as any
  if (validator.isEmpty(trimString(data.topic))) errors.topic = 'Please enter topic.'
  if (!data?.subId && !data?.workflow_form_id) errors.workflow_form_id = 'Please select a statistics capture form.'
  if (validator.isEmpty(trimString(data.assignedTo))) errors.assignedTo = 'Please select assignee.'

  if (validator.isEmpty(trimString(data.startDate))) {
    errors.startDate = 'Please enter start date.'
  } else if (!validator.isDate(data.startDate)) {
    errors.startDate = 'Please enter a valid date in DD/MM/YYYY format.'
  }

  if (validator.isEmpty(trimString(data.endDate))) {
    errors.endDate = 'Please enter end date.'
  } else if (!validator.isDate(data.endDate)) {
    errors.endDate = 'Please enter a valid date in DD/MM/YYYY format.'
  }

  if (data?.frequency === '1' && data?.days?.length < 1) errors.days = 'Please select week days.'
  if (data?.frequency === '2' && data?.day?.length < 1) errors.day = 'Please select month day.'

  return { errors, isValid: Object.keys(errors).length <= 0 }
}

export const EditReportValidation = (data: any, fieldsToValid: any, reviewByBypass?: boolean) => {
  let errors = {} as any

  fieldsToValid?.map((field: any) => {
    if (data[field?.title_key] === null || data[field?.title_key] === undefined || data[field?.title_key] === '') {
      errors[field?.title_key] = `Please enter ${field?.title?.toLowerCase()}.`
    }
    return true
  })

  if (validator.isEmpty(trimString(data.prepared_by))) {
    errors.prepared_by = 'Please enter prepared by.'
  }

  if (validator.isEmpty(trimString(data.prepared_on))) {
    errors.prepared_on = 'Please enter the date prepared on.'
  } else if (!validator.isDate(data.prepared_on)) {
    errors.prepared_on = 'Please enter a valid date in DD/MM/YYYY format.'
  }

  // if (validator.isEmpty(trimString(data.reviewed_by)) && !reviewByBypass) {
  //   errors.reviewed_by = 'Please enter reviewed by.'
  // }

  if (validator.isEmpty(trimString(data.reviewed_on)) && !reviewByBypass) {
    errors.reviewed_on = 'Please enter the date reviewed on.'
  } else if (!validator.isDate(data.reviewed_on) && !reviewByBypass) {
    errors.reviewed_on = 'Please enter a valid date in DD/MM/YYYY format.'
  }

  return { errors, isValid: Object.keys(errors).length === 0 }
}

export const FromToDateValidator = (data: any) => {
  let errors = {} as any

  if (validator.isEmpty(trimString(data.fromDate))) {
    errors.fromDate = 'Please enter the from date.'
  } else if (!validator.isDate(data.fromDate)) {
    errors.fromDate = 'Please enter a valid date in DD/MM/YYYY format.'
  }

  if (validator.isEmpty(trimString(data.toDate))) {
    errors.toDate = 'Please enter the to date.'
  } else if (!validator.isDate(data.toDate)) {
    errors.toDate = 'Please enter a valid date in DD/MM/YYYY format.'
  }

  return { errors, isValid: Object.keys(errors).length === 0 }
}
